import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "FileRaw"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21.9 6.75L21.645 12.75L21.45 16.155L21.1425 13.5L20.6325 9.405H19.1175L18.6075 13.5L18.3 16.155L18.105 12.75L17.85 6.75H16.5L17.25 17.25H18.9525L19.5225 13.5525L19.8675 10.5L19.875 10.4775L19.8825 10.5L20.2275 13.5525L20.7975 17.25H22.5L23.25 6.75H21.9ZM13.5 6.75H10.5C9.67157 6.75 9 7.42157 9 8.25V17.25H10.5V13.5H13.5V17.25H15V8.25C15 7.42157 14.3284 6.75 13.5 6.75ZM10.5 12V8.25H13.5V12H10.5ZM7.5 11.25V8.25C7.5 7.42157 6.82843 6.75 6 6.75H1.5V17.25H3V12.75H4.11L5.865 17.25H7.5L5.7225 12.75H6C6.82843 12.75 7.5 12.0784 7.5 11.25ZM3 8.25H6V11.25H3V8.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/FileRaw.vue"]]);
